import React from "react";
import "../theme/AdministracionCatalogo.css";
import {AzureAD, AuthenticationState} from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {authProvider} from "../context/authProvider";
import {useNavigate} from "react-router-dom";
import {TableMisSolicitudes} from "../components/TableMisSolicitudes";
import {BtnGoBack} from "../components/Buttons/BtnGoBack";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook


export const MisSolicitudes = () => {
    const authProvider = useDynamicAuth(); // Usar el hook
    const navigate = useNavigate();

    return (
        <AzureAD provider={authProvider}>
            {({authenticationState, accountInfo}) => {
                const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

                if (isAuthenticated) {
                    return (
                        <div className="body-color-admin">
                            <div className="title-name-admin">
                                <BtnGoBack caption="Volver a inicio"/>
                            </div>
                            <TableMisSolicitudes/>
                        </div>
                    );
                }
            }}
        </AzureAD>
    );
};
